import React from 'react';
import clsx from 'clsx';

import { Alert, Text } from 'reaxl';

function WalletServicesErrorAlert({ className, isSavingError = true } = {}) {
    return (
        <Alert
            data-cmp="wallet-payment-calc-error-alert"
            className={clsx('text-size-400', className)}
            bsStyle="danger"
        >
            <Text weight="bold">
                Whoops! We experienced an issue&nbsp;
                {isSavingError ? 'with saving your changes' : 'on our side'}.
            </Text>
            &nbsp;Please try again.
        </Alert>
    );
}

export default WalletServicesErrorAlert;
